<template>
  <div class="page-wrapper">
    <breadcrumb :items="breadcrumbItems" />
    <carregamento v-if="carregando" />
    <main
      class="main-content"
      v-else
    >
      <div class="content-card">
        <!-- Breadcrumb -->

        <!-- Título -->
        <h1 class="page-title">{{ vaga.titulo }}</h1>

        <!-- Período, Local, Tipo e Status -->
        <div class="info-row">
          <div class="info-item">
            <span class="info-label">Período de Inscrição:</span>
            <span class="info-date">{{
              formatarData(vaga.dataInicioInscricao)
            }}</span>
            <span class="info-date highlight">{{
              formatarData(vaga.dataFimInscricao)
            }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Local da vaga:</span>
            <span class="info-value">{{ vaga.localVaga }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Tipo da vaga:</span>
            <span class="tipo-vaga-badge" :class="tipoVagaClasse">
              {{ tipoVagaTexto }}
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">Status:</span>
            <span
              class="status-badge"
              :class="statusEfetivo.toLowerCase()"
            >
              <template v-if="statusEfetivo === 'ABERTA'"
                >Inscrições Abertas</template
              >
              <template v-else-if="statusEfetivo === 'BREVE'"
                >Inscrições em Breve</template
              >
              <template v-else-if="statusEfetivo === 'ENCERRADA'"
                >Inscrições Encerradas</template
              >
              <template v-else-if="statusEfetivo === 'CANCELADA'"
                >Vaga Cancelada</template
              >
              <template v-else>{{ statusEfetivo }}</template>
            </span>
          </div>
        </div>

        <!-- Painel de Métricas de Engajamento (Visível para Autor, Coordenador e Admin) -->
        <div
          class="metrics-panel"
          v-if="podeEditarOuExcluir"
        >
          <div class="metric-card">
            <div class="metric-info">
              <span class="metric-value">{{ vaga.visualizacoes || 0 }}</span>
              <span class="metric-label">Visualizações</span>
            </div>
          </div>
          <div
            class="metric-card"
            title="Mede a quantidade de acessos ao link de inscrição. Não garante o preenchimento do formulário externo."
          >
            <div class="metric-info">
              <span class="metric-value">{{ vaga.cliquesInscricao || 0 }}</span>
              <span class="metric-label">Acessos à Inscrição</span>
            </div>
          </div>
        </div>

        <!-- Núcleo -->
        <div class="nucleo-label">
          {{ vaga.acaoTitulo }}
        </div>

        <!-- Divisor roxo -->
        <hr class="divider" />

        <!-- Tags -->
        <div class="tags-row">
          <span
            class="tag"
            v-for="tag in vaga.tags"
            :key="tag"
            >{{ tag }}</span
          >
        </div>

        <!-- Texto da vaga -->
        <div class="vaga-text">
          <p>
            {{ vaga.textoInformativo }}
          </p>
        </div>

        <!-- Seção NERDS com imagem -->
        <div class="nerds-section">
          <div class="nerds-image-wrapper">
            <img
              :src="vaga.imagemUrl"
              :alt="vaga.descricaoImagem || 'Imagem da Vaga'"
              class="nerds-image"
            />
          </div>
          <div class="nerds-text">
            <h2 class="nerds-title">{{ vaga.acaoTitulo }}</h2>
            <p>
              {{ vaga.textoDescricaoAcao }}
            </p>
          </div>
        </div>

        <!-- Botões de ação -->
        <div class="action-buttons">
          <button
            class="btn btn-outline"
            v-if="podeEditarOuExcluir"
            @click="irParaEdicao"
          >
            Editar Vaga
          </button>
          <button
            class="btn btn-danger"
            v-if="podeEditarOuExcluir"
            @click="confirmarExclusao"
          >
            Excluir Vaga
          </button>
          <a
            class="btn btn-outline"
            v-if="vaga.linkEdital"
            :href="vaga.linkEdital"
            target="_blank"
            @click="handleCliqueInscricao"
            >Visualizar Edital</a
          >

          <template v-if="statusEfetivo === 'ABERTA' && vaga.linkInscricao">
            <a
              class="btn btn-primary"
              :href="vaga.linkInscricao"
              target="_blank"
              @click="handleCliqueInscricao"
              >Realizar Inscrição</a
            >
          </template>
          <template v-else-if="statusEfetivo === 'CANCELADA'">
            <button
              class="btn btn-disabled"
              disabled
            >
              Vaga Cancelada
            </button>
          </template>
          <template v-else-if="statusEfetivo === 'ENCERRADA'">
            <button
              class="btn btn-disabled"
              disabled
            >
              Inscrições Encerradas
            </button>
          </template>
        </div>
      </div>
    </main>

    <!-- Modal para Usuário Não Logado -->
    <div
      v-if="mostrarModalLogin"
      class="modal-overlay"
      @click.self="mostrarModalLogin = false"
    >
      <div class="modal-login-card">
        <div class="modal-login-header">
          <div class="modal-icon-wrapper">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
              <polyline points="10 17 15 12 10 7"></polyline>
              <line
                x1="15"
                y1="12"
                x2="3"
                y2="12"
              ></line>
            </svg>
          </div>
          <h3>Atenção</h3>
        </div>
        <div class="modal-login-body">
          <p>
            Para entrar em contato com os coordenadores desta ação, por favor
            faça login.
          </p>
        </div>
        <div class="modal-login-footer">
          <button
            class="btn-modal-ok"
            @click="mostrarModalLogin = false"
          >
            OK
          </button>
          <button
            class="btn-modal-entrar"
            @click="irParaLogin"
          >
            Entrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";
import { useRoute, useRouter } from "vue-router";
import vagasService from "@/service/vagasService";
import acaoService from "@/service/acaoService";
import userInfos from "@/utils/userInfos";
import { useAuthStore } from "@/stores/auth";
import { formatarData } from "@/utils/FormatarEntradas";
import Carregamento from "@/components/common/Carregamento.vue";
import dayjs from "dayjs";

const vaga = ref({});
const isCoordenador = ref(false);

const route = useRoute();
const router = useRouter();
const carregando = ref(false);
const authStore = useAuthStore();

const tipoVagaTexto = computed(() => {
  if (vaga.value?.isEstagiario) return "Estágio";
  const remunerada = vaga.value?.isBolsistaRemunerado ?? vaga.value?.remunerada ?? false;
  return remunerada ? "Remunerada" : "Agente";
});

const tipoVagaClasse = computed(() => {
  if (vaga.value?.isEstagiario) return "estagio";
  const remunerada = vaga.value?.isBolsistaRemunerado ?? vaga.value?.remunerada ?? false;
  return remunerada ? "remunerada" : "voluntaria";
});

const statusEfetivo = computed(() => {
  if (!vaga.value) return "ABERTA";

  if (vaga.value.status === "CANCELADA") return "CANCELADA";
  if (vaga.value.status === "ENCERRADA") return "ENCERRADA";

  const extrairApenasData = (dataVal) => {
    if (!dataVal) return null;
    if (Array.isArray(dataVal))
      return `${dataVal[0]}-${String(dataVal[1]).padStart(2, "0")}-${String(dataVal[2]).padStart(2, "0")}`;
    if (typeof dataVal === "string") return dataVal.split("T")[0];
    return dataVal;
  };

  const hoje = dayjs().startOf("day");

  if (vaga.value.dataFimInscricao) {
    const fimStr = extrairApenasData(vaga.value.dataFimInscricao);
    if (fimStr) {
      const fim = dayjs(fimStr).startOf("day");
      if (hoje.isAfter(fim)) {
        return "ENCERRADA";
      }
    }
  }

  if (vaga.value.dataInicioInscricao) {
    const inicioStr = extrairApenasData(vaga.value.dataInicioInscricao);
    if (inicioStr) {
      const inicio = dayjs(inicioStr).startOf("day");
      if (hoje.isBefore(inicio)) {
        return "BREVE";
      }
    }
  }

  return vaga.value.status || "ABERTA";
});

const podeEditarOuExcluir = computed(() => {
  const user = userInfos.getUserInfos();
  if (!user) return false;

  const userId = user.id || user.userId || user.sub;
  const isAutor = Boolean(
    vaga.value?.autorPublicacaoId && vaga.value.autorPublicacaoId === userId
  );
  const isAdmin =
    authStore.hasRole("ADMIN") ||
    authStore.hasRole("PREX_ADMIN") ||
    authStore.hasRole("ADMINISTRADOR");
  const isCoord = isCoordenador.value;

  return isAutor || isCoord || isAdmin;
});

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id || vaga.value.acaoId || vaga.value.acao?.id;
  if (acaoId) {
    return [
      { label: "Início", to: "/" },
      { label: "Ações", to: "/suas-acoes" },
      { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
      { label: "vagas", to: `/acao/${acaoId}/vagas` },
      { label: vaga.value.titulo || "Vaga", to: `/acao/${acaoId}/Atividades` },
    ];
  } else {
    return [
      { label: "Início", to: "/" },
      { label: "Vagas", to: "/vagas" },
      { label: vaga.value.titulo || "Vaga", to: `/vagas/${vaga?.titulo}` },
    ];
  }
});

async function registrarVisualizacaoSessao() {
  if (!vaga.value?.id) return;
  const vagaId = vaga.value.id;
  const storageKey = `vaga_vista_${vagaId}`;

  if (!sessionStorage.getItem(storageKey)) {
    sessionStorage.setItem(storageKey, "true");
    try {
      await vagasService.registrarVisualizacao(vagaId);
    } catch (error) {
      console.error("Erro ao registrar visualização única:", error);
    }
  }
}

async function buscarinformacoesVaga() {
  const vagaId = route.params.vagaId || route.params.id;
  if (!vagaId) return;

  try {
    const resById = await vagasService.getVagaById(vagaId);
    const dados = resById?.data || resById;
    if (dados) {
      vaga.value = dados;
      await registrarVisualizacaoSessao();
    }
  } catch (error) {
    console.error("Erro ao buscar vaga por ID:", error);
  }
}

async function verificarCoordenador() {
  try {
    const user = userInfos.getUserInfos();
    if (!user) {
      isCoordenador.value = false;
      return;
    }

    const targetAcaoId =
      route.params.id || vaga.value?.acaoId || vaga.value?.acao?.id;
    if (!targetAcaoId) {
      isCoordenador.value = false;
      return;
    }

    isCoordenador.value = await acaoService.verificarCoordenador(targetAcaoId);
  } catch (error) {
    console.error("Erro ao verificar coordenação:", error);
    isCoordenador.value = false;
  }
}

function irParaEdicao() {
  const targetAcaoId =
    route.params.id || vaga.value?.acaoId || vaga.value?.acao?.id;
  const targetVagaId = vaga.value?.id || route.params.vagaId;

  if (targetAcaoId && targetVagaId) {
    router.push({
      name: "editar-vaga",
      params: { id: targetAcaoId, vagaId: targetVagaId },
    });
  } else if (targetVagaId) {
    router.push(`/editar-vaga/${targetVagaId}`);
  }
}

async function confirmarExclusao() {
  if (confirm("Tem certeza que deseja excluir esta vaga?")) {
    try {
      await vagasService.deleteVaga(vaga.value.id);
      alert("Vaga excluída com sucesso!");
      const acaoId =
        route.params.id || vaga.value.acaoId || vaga.value.acao?.id;
      if (acaoId) {
        router.push(`/acao/${acaoId}/vagas`);
      } else {
        router.push("/vagas");
      }
    } catch (error) {
      console.error("Erro ao excluir vaga:", error);
      alert("Ocorreu um erro ao excluir a vaga.");
    }
  }
}

const mostrarModalLogin = ref(false);

function irParaLogin() {
  router.push("/login");
}

onMounted(async () => {
  carregando.value = true;
  await buscarinformacoesVaga();
  await verificarCoordenador();
  carregando.value = false;
});
</script>

<style scoped>
.main-content {
  flex: 1;
  width: 100%;
  margin: 0;
  padding: 0;
}

.content-card {
  background: #ffffff;
  border-radius: 0;
  box-shadow: none;
  min-height: 100vh;
}

/* ── Título ── */
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.info-date {
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 2px 10px;
  color: #444;
  background: #fafafa;
}

.info-date.highlight {
  border-color: #3b2078;
  color: white;
  background: #772fa2;
  font-weight: 600;
}

.info-value {
  font-size: 13px;
  color: #555;
}

.tipo-vaga-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
}

.tipo-vaga-badge.remunerada {
  background-color: #f3e8ff;
  color: #772fa2;
  border: 1px solid #772fa2;
}

.tipo-vaga-badge.voluntaria {
  background-color: #e0f2fe;
  color: #0284c7;
  border: 1px solid #0284c7;
}

.tipo-vaga-badge.estagio {
  background-color: #fef3c7;
  color: #b45309;
  border: 1px solid #fde68a;
}

.status-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
}

.status-badge.aberta {
  background-color: #dcfce7;
  color: #15803d;
  border: 1px solid #86efac;
}

.status-badge.breve {
  background-color: #e0f2fe;
  color: #0369a1;
  border: 1px solid #7dd3fc;
}

.status-badge.encerrada {
  background-color: #ffedd5;
  color: #c2410c;
  border: 1px solid #fdba74;
}

.status-badge.cancelada {
  background-color: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.metrics-panel {
  display: flex;
  gap: 16px;
  margin: 16px 0;
  flex-wrap: wrap;
}

.metric-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 18px;
  min-width: 160px;
}

.metric-info {
  display: flex;
  gap: 10px;
  align-items: center;
}

.metric-value {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.metric-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.nucleo-label {
  font-size: 13px;
  color: #555;
  margin-bottom: 14px;
}

.divider {
  border-top: 3px solid black;
  margin: 0 0 16px 0;
}

/* ── Tags ── */
.tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.tag {
  font-size: 12px;
  border: 2px solid #bbb;
  border-radius: 5px;
  padding: 3px 12px;
  color: #444;
  background: #fff;
}

/* ── Texto da vaga ── */
.vaga-text p {
  font-size: 13.5px;
  line-height: 1.7;
  color: #333;
  margin: 0;
}

.nerds-section {
  display: flex;
  gap: 20px;
  margin-top: 24px;
  align-items: flex-start;
}

.nerds-image-wrapper {
  flex-shrink: 0;
}

.nerds-image {
  width: 220px;
  height: 140px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
}

.nerds-text {
  flex: 1;
}

.nerds-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.nerds-text p {
  font-size: 13px;
  line-height: 1.7;
  color: #333;
  margin: 0;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
}

.btn {
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  transition:
    opacity 0.2s,
    background 0.2s;
}

.btn-outline {
  background: #fff;
  border: 2px solid #3b2078;
  color: #3b2078;
}

.btn-outline:hover {
  background: #f0eaff;
}

.btn-primary {
  background: #3b2078;
  color: #fff;
}

.btn-primary:hover {
  background: #2e1860;
}

.btn-disabled {
  background: #cbd5e1;
  color: #64748b;
  cursor: not-allowed;
  border: none;
}

.btn-danger {
  background: #dc2626;
  color: #fff;
  text-decoration: none;
}

.btn-danger:hover {
  background: #b91c1c;
}

/* ── Modal Usuário Não Logado ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
}

.modal-login-card {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 420px;
  padding: 24px;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: modalFadeIn 0.25s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-login-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modal-icon-wrapper {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: hsl(255, 50%, 95%);
  color: #3b2078;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-login-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.modal-login-body p {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
  margin: 0;
}

.modal-login-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.btn-modal-ok {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1.5px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-modal-ok:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.btn-modal-entrar {
  padding: 8px 24px;
  border-radius: 8px;
  border: none;
  background: #3b2078;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(59, 32, 120, 0.2);
}

.btn-modal-entrar:hover {
  background: #2c175c;
  box-shadow: 0 4px 8px rgba(59, 32, 120, 0.3);
}
</style>
